import { useState } from "react";

import { FreelancerDashboardBidsLazy } from "../../lazy";
import { MyWorkListingPage } from "../my-work-listing-page";

export const FreelancerDashboardBidsListingPage = () => {
  const [showClosedApplications, setShowClosedApplications] = useState(false);

  const checkboxProps = {
    checkboxText: "Show closed applications",
    isChecked: showClosedApplications,
    setIsChecked: setShowClosedApplications,
  };

  return (
    <MyWorkListingPage pageTitle="Applications" checkboxProps={checkboxProps}>
      <FreelancerDashboardBidsLazy
        showClosedApplications={showClosedApplications}
      />
    </MyWorkListingPage>
  );
};
